import React from 'react';
import useDispatchProgramService from '../../../app/services/hooks/useDispatchProgramService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import { DispatchProgramStatusRequestDataForm } from '../../../app/models/DispatchProgram';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    dispatchProgramId: number;
    statuses: DispatchProgramStatusRequestDataForm[];
    selectedStatus: DispatchProgramStatusRequestDataForm;
    callbackSuccess?: () => void;
}

const DispatchProgramChangeStatus = ({
    dispatchProgramId,
    statuses,
    selectedStatus,
    callbackSuccess
}: Props) => {

    const [selected, setSelected] = React.useState(selectedStatus);

    const { 
        preparationStatusDispatchProgram,
        planificationStatusDispatchProgram,
        dispatchStatusDispatchProgram,
        finishedStatusDispatchProgram,
        annulledStatusDispatchProgram
    } = useDispatchProgramService();

    const eventChangeStatus = {
        onSuccess: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
            }
    
            useReactConfirmAlert().successAlert({
                title: 'Éxito',
                message: `Se ha cambiado el estado del despacho #${dispatchProgramId}`
            });
        },
        onError: (response: ServiceResponse) => {
            if (callbackSuccess) {
                callbackSuccess();
            }
    
            toast.error(response.message);
        }
    };

    const changeStatus = (value: string) => {
        if (value === selected.id) return;
    
        const _status = statuses.find(
            (status: DispatchProgramStatusRequestDataForm) => status.id === value
        );
    
        setSelected(_status!);
    
        const _text =
            'Está a punto de cambiar el estado de la cotización #' +
            dispatchProgramId +
            ' a ' +
            (_status ? _status.name : '');
    
        useReactConfirmAlert().requestConfirmation({
            title: '¿Está seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Sí, cambiar estado',
                    onClick: () => {
                        switch (value) {
                            case 'PREPARACION':
                                preparationStatusDispatchProgram(dispatchProgramId, eventChangeStatus);
                                break;
                            case 'PLANIFICACION':
                                planificationStatusDispatchProgram(dispatchProgramId, eventChangeStatus);
                                break;
                            case 'DESPACHO':
                                dispatchStatusDispatchProgram(dispatchProgramId, eventChangeStatus);
                                break;
                            case 'FINALIZADO':
                                finishedStatusDispatchProgram(dispatchProgramId, eventChangeStatus);
                                break;
                            case 'ANULAR':
                                annulledStatusDispatchProgram(dispatchProgramId, eventChangeStatus);
                                break;
                            default:
                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: 'Opción no encontrada.'
                                });
                                setSelected(selectedStatus);
                                break;
                        }
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El estado de la cotización no se ha cambiado.'
                            });
                            setSelected(selectedStatus);
                        }, 0);
                    }
                }
            },
            onClickOutsideFunction: () => {
                setSelected(selectedStatus); 
            }
        });
    };
    
    
    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(e.target.value)}
        >
            <option value={selectedStatus.id}>{selectedStatus.name}</option>
            {statuses.map((status) => {
                return (
                    <option key={status.id} value={status.id}>
                        {status.name}
                    </option>
                );
            })}
        </select>
    );
};

export default DispatchProgramChangeStatus;
